<template>
  <div class="new-game-page">
    <button class="btn btn-primary btn-lg" :disabled="creatingRef" @click="createGame">
      {{ creatingRef ? 'Creating…' : 'New game' }}
    </button>
    <p v-if="errorRef" class="error">{{ errorRef }}</p>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useGamesApi } from './GamesApi'

const gamesApi = useGamesApi()
const router = useRouter()

const creatingRef = ref(false)
const errorRef = ref('')

async function createGame() {
  creatingRef.value = true
  errorRef.value = ''
  try {
    const def = await gamesApi.createGame()
    await router.replace(`/games/${def.id}/design`)
  } catch (e) {
    errorRef.value = `Couldn't create the game: ${(e as Error).message}`
  } finally {
    creatingRef.value = false
  }
}
</script>

<style lang="scss" scoped>
.new-game-page {
  padding: 1rem;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .error {
    color: #000;
    font-size: 0.875rem;
  }
}
</style>
